<template lang="pug">
  div(:style="{ columns: columns }")
    v-card.list-card.mb-4(v-for="content in contents" :key="content.id" xs6)
      v-img(v-if="content.image" :src="content.image" :aspect-ratio="16/9")
      v-card-title.grey.lighten-4
        router-link(:to="contentUrl(content)").subheading {{content.title}}
      v-card-text(v-if="content.preamble") {{content.preamble}}

</template>
<style lang="stylus" scoped>
.list-card
  display inline-block
  width 100%
  
</style>


<script>
import ContentUrl from '../../mixins/content-url'
export default {
  props: ['extra', 'isPage', 'menu', 'items'],
  mixins: [ContentUrl],
  computed: {
    columns() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 1
        case 'sm': return 1
        case 'md': return 2
        case 'lg': return 2
        case 'xl': return 3
      }
    },
    contents() {
      if (this.items) {
        return this.items
      } else if (this.extra && this.extra.content) {
        return JSON.parse(this.extra.content)
      } else {
        return [] 
      }
    }
  },
  methods: {
  }
}
</script>
